var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineInformationDeskCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5259 10.0086C26.5259 10.6168 26.6457 11.2191 26.8784 11.781C27.1112 12.3429 27.4523 12.8535 27.8824 13.2835C28.3125 13.7136 28.823 14.0548 29.3849 14.2875C29.9468 14.5203 30.5491 14.6401 31.1573 14.6401C31.7655 14.6401 32.3678 14.5203 32.9297 14.2875C33.4916 14.0548 34.0022 13.7136 34.4322 13.2835C34.8623 12.8535 35.2034 12.3429 35.4362 11.781C35.6689 11.2191 35.7887 10.6168 35.7887 10.0086C35.7887 8.78029 35.3008 7.60227 34.4322 6.73371C33.5637 5.86515 32.3856 5.3772 31.1573 5.3772C29.929 5.3772 28.751 5.86515 27.8824 6.73371C27.0138 7.60227 26.5259 8.78029 26.5259 10.0086Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2086 23.9058V21.5915C24.2086 19.7483 24.9408 17.9805 26.2442 16.6771C27.5476 15.3737 29.3153 14.6415 31.1586 14.6415C33.0018 14.6415 34.7696 15.3737 36.073 16.6771C37.3764 17.9805 38.1086 19.7483 38.1086 21.5915V23.9058M18.8572 23.9115H38.1086M10.2972 16.0344C11.5948 16.0344 12.8393 15.5189 13.7569 14.6013C14.6745 13.6837 15.19 12.4392 15.19 11.1415C15.19 9.84385 14.6745 8.59933 13.7569 7.68174C12.8393 6.76415 11.5948 6.24866 10.2972 6.24866C8.99949 6.24866 7.75497 6.76415 6.83738 7.68174C5.91979 8.59933 5.4043 9.84385 5.4043 11.1415C5.4043 12.4392 5.91979 13.6837 6.83738 14.6013C7.75497 15.5189 8.99949 16.0344 10.2972 16.0344Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8572 24.5972C18.8572 22.3266 17.9552 20.1489 16.3496 18.5434C14.7441 16.9378 12.5664 16.0358 10.2958 16.0358C8.02517 16.0358 5.84754 16.9378 4.24196 18.5434C2.63638 20.1489 1.73438 22.3266 1.73438 24.5972V28.2658H5.4058L6.62866 38.0486H13.9658L15.1887 28.2658H18.8572V24.5972Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineInformationDeskCustomer);
export default __webpack_public_path__ + "static/media/streamline_information-desk-customer.4c1117b260caf107ccb140be1ffd793c.svg";
export { ForwardRef as ReactComponent };